import { CircularProgress, Link } from '@mui/material';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';
import { useAffectedItems } from '@retail/calculus/context';

interface Props {
  supplierNumber: number;
  conditionIds: number[];
  openItemsAffectedModal: () => void;
}

export const ItemsAffected = ({ supplierNumber, conditionIds, openItemsAffectedModal }: Props) => {
  const { assortmentId } = useSelectedOrgUnit();

  const { totalItems, isLoading } = useAffectedItems({
    assortmentId,
    conditionIds,
    supplierNumber,
  });

  return (
    <Link component="button" onClick={openItemsAffectedModal} sx={{ fontWeight: 500 }}>
      {isLoading ? <CircularProgress size="16px" /> : totalItems}
    </Link>
  );
};
